<template>
  <div class="video-live">
    <div id="player" class="player"></div>
  </div>
</template>
<script>
import * as api from '../../../api/api.js'
export default {
  name: 'LivePlayer',
  props: ['activeId'],
  data () {
    return {
      webSDK: null
    }
  },
  watch: {
    async activeId (val, oldVal) {
      if (val !== oldVal) {
        this.initPlayer()
      }
    }
  },
  methods: {
    async initPlayer () {
      if (this.activeId !== undefined){
        console.log("接收到的活动ID：",this.activeId)
        let data = {
          activityId: this.activeId, // 活动id
          mode: 1, // 1公开状态，观众自己输入昵称, 2自定义，用户昵称随接口提交
          nickname: '', // 用户昵称  当Mode为2时为必传
          userIdStr: '' // 用户ID 当Mode为2时为必传
        }
        let res = await this.$http.post(api.PlayToken, data)
        if (res.data.success) {
          this.webSDK = new window.ByteLiveWebSDK({
            activityId: this.activeId,
            token: res.data.data.token,
            service: 'YDlivesaas',
            mode: 1,
            modules: [
              {
                id: 'player', // 页面元素 ID, 播放器模块会嵌入到此元素内
                mode: 'player'
              }
            ],
            options: {
              // mobileBackgroundTransparent: true,
              // saveUserInfo: true
            }
          })
        }
      }
    }
  },
  async mounted () {
    this.initPlayer()
  }
}
</script>

<style scoped>
  .player{height: 200px;}
</style>



// WEBPACK FOOTER //
// src/views/zb/components/LivePlayer.vue